'use strinct'

import React from 'react';

export default class Area extends React.Component {
  render() {
    return this.props.children!==undefined && this.props.children!==null ? (
      <div className="area" style={{padding: 5, paddingBottom:30, fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif", textAlign:"left"}}>
        <div style={{fontSize:"16pt", fontWeight:"bold", borderBottom: "solid 1px #e9e7e6", marginBottom:15}}>
          {this.props.title}
        </div>
        <div style={{display:"flex", justifyContent: "space-between", backgroundColor:"#f7f7f7" ,flexWrap:"wrap", padding:40}}>
          {this.props.children}
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./views/components/Area2.jsx